export default __webpack_public_path__ + "static/media/92percent.b5bdf806.png";